import PropTypes from 'prop-types'
import { Col, Row } from 'react-bootstrap'
import { chunk, map } from 'lodash'
import { filterPostsByTopicSlug } from 'hello_baby/lib'
import { PostShape, TopicShape } from 'hello_baby/lib/prop-types'
import PostList from '../post-list'
import css from './gear-view.scss'

const NUM_COLUMNS = 2

const GearView = ({ posts, subTopics }) => (
  <>
    {map(chunk(subTopics, NUM_COLUMNS), (subTopicsRow, idx) => (
      <GearRow key={idx} posts={posts} subTopics={subTopicsRow} />
    ))}
  </>
)

GearView.propTypes = {
  posts: PropTypes.arrayOf(PropTypes.shape(PostShape)).isRequired,
  subTopics: PropTypes.arrayOf(PropTypes.shape(TopicShape)).isRequired,
}

const GearRow = ({ posts, subTopics }) => (
  <Row>
    {map(subTopics, (subTopic) => (
      <Col key={subTopic.slug} sm={12 / NUM_COLUMNS} className={css.postColumn}>
        <PostList
          topic={subTopic}
          posts={filterPostsByTopicSlug(posts, subTopic.slug)}
        />
      </Col>
    ))}
  </Row>
)

GearRow.propTypes = {
  posts: PropTypes.arrayOf(PropTypes.shape(PostShape)).isRequired,
  subTopics: PropTypes.arrayOf(PropTypes.shape(TopicShape)).isRequired,
}

export default GearView
